"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Button, ButtonSize, ButtonVariant, Checkbox, Progress, ProgressColor, Text, TextColor, TextSize, TextWeight } from "../../components";
import { ProductToReturnListItem, ReturnMethodOption, StepHeader } from "./components";
const RETURN_STEPS = {
  PRODUCTS: 1,
  SHIPPING: 2,
  CONFIRMATION: 3
};

// Custom hook for return form state
const useReturnFormState = () => {
  const $ = _c(12);
  const [currentStep, setCurrentStep] = useState(RETURN_STEPS.PRODUCTS);
  let t0;
  if ($[0] !== currentStep) {
    t0 = step => currentStep === step;
    $[0] = currentStep;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isStepActive = t0;
  let t1;
  if ($[2] !== currentStep) {
    t1 = step_0 => currentStep > step_0;
    $[2] = currentStep;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const isStepCompleted = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = step_1 => {
      setCurrentStep(step_1);
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const resetStep = t2;
  let t3;
  if ($[5] !== currentStep) {
    t3 = () => {
      if (currentStep < RETURN_STEPS.CONFIRMATION) {
        setCurrentStep(currentStep + 1);
      }
    };
    $[5] = currentStep;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const goToNextStep = t3;
  let t4;
  if ($[7] !== currentStep || $[8] !== goToNextStep || $[9] !== isStepActive || $[10] !== isStepCompleted) {
    t4 = {
      currentStep,
      setCurrentStep,
      isStepActive,
      isStepCompleted,
      resetStep,
      goToNextStep
    };
    $[7] = currentStep;
    $[8] = goToNextStep;
    $[9] = isStepActive;
    $[10] = isStepCompleted;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};

// Main component
const CustomReturnForm = t0 => {
  const $ = _c(48);
  const {
    customReturnForm,
    loadingCustomReturnForm,
    onSubmitReturn,
    loadingSubmit,
    customReturnUserForm,
    isUserFormValid: t1,
    userFormData,
    loadingCreateCustomReturn
  } = t0;
  const isUserFormValid = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const [selectedProducts, setSelectedProducts] = useState(t2);
  const [selectedReturnMethod, setSelectedReturnMethod] = useState(null);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("withoutpayment");
  const [paymentTerms, setPaymentTerms] = useState(false);
  const [dhlParcelPoint, setDhlParcelPoint] = useState(null);
  const [showDhlModal, setShowDhlModal] = useState(false);
  const [newsletterTerms, setNewsletterTerms] = useState(false);
  const returnFormState = useReturnFormState();
  let t3;
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      window.addEventListener("message", msg => {
        if (msg.origin === "https://parcelshop.dhl.pl") {
          let point;
          if (typeof msg.data === "object" && msg.data !== null) {
            point = msg.data;
          } else {
            point = JSON.parse(msg.data);
          }
          setDhlParcelPoint(point);
          setShowDhlModal(false);
        }
      }, false);
    };
    t4 = [];
    $[1] = t3;
    $[2] = t4;
  } else {
    t3 = $[1];
    t4 = $[2];
  }
  useEffect(t3, t4);
  let t5;
  if ($[3] !== dhlParcelPoint || $[4] !== onSubmitReturn || $[5] !== selectedPaymentMethod || $[6] !== selectedProducts || $[7] !== selectedReturnMethod) {
    t5 = () => {
      const formattedSelectedProducts = selectedProducts.map(_temp);
      if (!selectedReturnMethod) {
        return;
      }
      onSubmitReturn(formattedSelectedProducts, selectedReturnMethod, selectedPaymentMethod, dhlParcelPoint);
    };
    $[3] = dhlParcelPoint;
    $[4] = onSubmitReturn;
    $[5] = selectedPaymentMethod;
    $[6] = selectedProducts;
    $[7] = selectedReturnMethod;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const handleSubmit = t5;
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = method => {
      setSelectedReturnMethod(method);
    };
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const handleSelectReturnMethod = t6;
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      setShowDhlModal(true);
    };
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const handleSelectDhlPoint = t7;
  const handleSubscribeNewsletter = _temp2;
  const handleVerifySubscription = _temp3;
  let t8;
  if ($[11] !== customReturnForm || $[12] !== newsletterTerms) {
    t8 = () => {
      if (!customReturnForm) {
        return null;
      }
      const {
        subscribed,
        unconfirmed
      } = customReturnForm.getResponse;
      if (subscribed && !unconfirmed) {
        return <div className="mb-6 border border-green-200 p-6 bg-green-50"><Text text={"Obni\u017Cony koszt zwrotu!"} weight={TextWeight.BOLD} fontSize={TextSize.M} /><Text text={"Zwrot produkt\xF3w jest ta\u0144szy dla subskrybent\xF3w newslettera. Dzi\u0119ki temu masz mo\u017Cliwo\u015B\u0107 zwrotu przesy\u0142ki do Paczkomatu\xAE za 8.99 PLN lub punktu DHL POP za 7.99 PLN"} fontSize={TextSize.S} /></div>;
      }
      if (!subscribed && !unconfirmed) {
        return <div className="mb-6 border border-yellow-200 p-6 bg-yellow-50"><div className="flex flex-col md:flex-row gap-4"><div className="flex-1"><Text text={"Chcesz obni\u017Cy\u0107 koszt zwrotu?"} weight={TextWeight.BOLD} fontSize={TextSize.M} /><Text text={"Zwrot produkt\xF3w jest ta\u0144szy dla subskrybent\xF3w newslettera. Zapisz si\u0119 do naszego newslettera aby otrzyma\u0107 mo\u017Cliwo\u015B\u0107 zwrotu do Paczkomatu\xAE za 8.99 PLN lub punktu DHL POP za 7.99 PLN"} fontSize={TextSize.S} /></div><div className="flex flex-col items-end gap-2"><div className="flex items-center gap-2"><input type="checkbox" id="newsletter-terms" checked={newsletterTerms} onChange={e => setNewsletterTerms(e.target.checked)} /><label htmlFor="newsletter-terms" className="text-sm">Akceptuję{" "}<a href="https://carry.pl/regulamin-sklepu" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">warunki newslettera</a></label></div><Button text={"Zapisz si\u0119"} variant={ButtonVariant.PRIMARY} size={ButtonSize.S} onClick={handleSubscribeNewsletter} disabled={!newsletterTerms} /></div></div></div>;
      }
      return <div className="mb-6 border border-blue-200 p-6 bg-blue-50"><div className="flex flex-col md:flex-row gap-4"><div className="flex-1"><Text text={"Potwierd\u017A subskrypcj\u0119 newslettera!"} weight={TextWeight.BOLD} fontSize={TextSize.M} /></div><div className="flex flex-col items-end gap-2"><Button text="POTWIERDZONO" variant={ButtonVariant.PRIMARY} size={ButtonSize.S} onClick={handleVerifySubscription} /></div></div></div>;
    };
    $[11] = customReturnForm;
    $[12] = newsletterTerms;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const getNewsletterSection = t8;
  let t9;
  if ($[14] !== showDhlModal) {
    t9 = showDhlModal && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"><div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-hidden"><div className="p-4 border-b"><div className="flex justify-between items-center"><Text text={"Wpisz sw\xF3j adres i wybierz dowolny punkt"} weight={TextWeight.BOLD} fontSize={TextSize.M} /><button onClick={() => setShowDhlModal(false)} className="text-gray-500 hover:text-gray-700">✕</button></div></div><iframe width="100%" height="600" src="https://parcelshop.dhl.pl/mapa?country=PL&ptype=packStation" className="border-0" /></div></div>;
    $[14] = showDhlModal;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== loadingCustomReturnForm) {
    t10 = loadingCustomReturnForm && <div className="flex flex-col gap-4 justify-center items-center h-full min-h-[calc(50vh-64px)]"><Progress color={ProgressColor.GRAYSCALE_400} /><Text text={"\u0141adowanie zam\xF3wienia"} color={TextColor.GRAYSCALE_400} fontSize={TextSize.S} /></div>;
    $[16] = loadingCustomReturnForm;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== customReturnForm || $[19] !== customReturnUserForm || $[20] !== dhlParcelPoint || $[21] !== getNewsletterSection || $[22] !== handleSubmit || $[23] !== isUserFormValid || $[24] !== loadingCreateCustomReturn || $[25] !== loadingCustomReturnForm || $[26] !== loadingSubmit || $[27] !== paymentTerms || $[28] !== returnFormState || $[29] !== selectedPaymentMethod || $[30] !== selectedProducts || $[31] !== selectedReturnMethod || $[32] !== userFormData?.accountNumber || $[33] !== userFormData?.apartmentNumber || $[34] !== userFormData?.city || $[35] !== userFormData?.houseNumber || $[36] !== userFormData?.name || $[37] !== userFormData?.postCode || $[38] !== userFormData?.street) {
    t11 = customReturnForm && !loadingCustomReturnForm && <div className="relative w-full min-h-[calc(100vh-500px)]"><div className="w-full max-w-screen-2xl mx-auto relative"><div className="grid grid-cols-1"><div className="p-4 lg:p-8 flex flex-col lg:overflow-y-auto"><StepSection $isActive={returnFormState.isStepActive(RETURN_STEPS.PRODUCTS)} $isCompleted={returnFormState.isStepCompleted(RETURN_STEPS.PRODUCTS)}><StepHeader stepNumber={1} title="Wybierz produkty do zwrotu" isActive={returnFormState.isStepActive(RETURN_STEPS.PRODUCTS)} isCompleted={returnFormState.isStepCompleted(RETURN_STEPS.PRODUCTS)} onEdit={() => returnFormState.resetStep(RETURN_STEPS.PRODUCTS)} />{returnFormState.isStepActive(RETURN_STEPS.PRODUCTS) && <div className="flex flex-col gap-4 min-h-[200px]">{customReturnForm.products.map(product_0 => <ProductToReturnListItem key={product_0.idOrderDetail} product={product_0} selectedProducts={selectedProducts} setSelectedProducts={setSelectedProducts} reasons={customReturnForm.reasons} />)}<div className="flex flex-col gap-2 justify-end items-end mt-auto">{selectedProducts.some(_temp4) && <Text text={"Wybierz ilo\u015B\u0107 i pow\xF3d zwrotu dla ka\u017Cdego produktu"} fontSize={TextSize.XS} color={TextColor.ERROR_700} />}<Button text="Dalej" variant={ButtonVariant.PRIMARY} size={ButtonSize.S} onClick={returnFormState.goToNextStep} disabled={selectedProducts.length === 0 || selectedProducts.some(_temp5)} /></div></div>}{returnFormState.isStepCompleted(RETURN_STEPS.PRODUCTS) && <div className="flex flex-col gap-4 min-h-[200px]">{selectedProducts.map(product_3 => <ProductToReturnListItem key={product_3.idOrderDetail} product={product_3} selectedProducts={selectedProducts} setSelectedProducts={setSelectedProducts} reasons={customReturnForm.reasons} isStepCompleted={true} />)}</div>}</StepSection><StepSection $isActive={returnFormState.isStepActive(RETURN_STEPS.SHIPPING)} $isCompleted={returnFormState.isStepCompleted(RETURN_STEPS.SHIPPING)}><StepHeader stepNumber={2} title={"Spos\xF3b dostawy i dane"} isActive={returnFormState.isStepActive(RETURN_STEPS.SHIPPING)} isCompleted={returnFormState.isStepCompleted(RETURN_STEPS.SHIPPING)} onEdit={() => returnFormState.resetStep(RETURN_STEPS.SHIPPING)} />{returnFormState.isStepActive(RETURN_STEPS.SHIPPING) && <div className="flex flex-col gap-4 min-h-[200px]">{getNewsletterSection()}<div className="flex flex-col md:flex-row gap-8 mb-6"><div className="w-full md:w-1/2"><Text text={"Wybierz spos\xF3b wysy\u0142ki"} weight={TextWeight.BOLD} fontSize={TextSize.M} /><div className="mt-4">{customReturnForm.returnMethods.map(method_0 => <ReturnMethodOption key={method_0.idReturnMethod} method={method_0} isSelected={selectedReturnMethod?.idReturnMethod === method_0.idReturnMethod} onSelect={handleSelectReturnMethod} onSelectDhlPoint={method_0.idReturnMethod === "3" ? handleSelectDhlPoint : undefined} dhlParcelPoint={method_0.idReturnMethod === "3" ? dhlParcelPoint : undefined} />)}</div></div><div className="w-full md:w-1/2">{customReturnUserForm}</div></div><div className="flex justify-end mt-auto"><Button text="Dalej" variant={ButtonVariant.PRIMARY} size={ButtonSize.S} onClick={returnFormState.goToNextStep} disabled={!selectedReturnMethod || selectedReturnMethod.idReturnMethod === "3" && !dhlParcelPoint || !isUserFormValid} /></div></div>}{returnFormState.isStepCompleted(RETURN_STEPS.SHIPPING) && <div className="flex flex-col gap-4">{selectedReturnMethod && <div className="p-4 bg-gray-50 border border-gray-200"><Text text={`Wybrany sposób: ${customReturnForm.returnMethods.find(m => m.idReturnMethod === selectedReturnMethod?.idReturnMethod)?.title}`} weight={TextWeight.BOLD} fontSize={TextSize.S} />{selectedReturnMethod.idReturnMethod === "3" && dhlParcelPoint && <div className="mt-2"><Text text={`Punkt DHL: ${dhlParcelPoint.name}`} fontSize={TextSize.S} /><Text text={`${dhlParcelPoint.street} ${dhlParcelPoint.streetNo}, ${dhlParcelPoint.zip} ${dhlParcelPoint.city}`} fontSize={TextSize.XS} color={TextColor.GRAYSCALE_600} /></div>}</div>}</div>}</StepSection><StepSection $isActive={returnFormState.isStepActive(RETURN_STEPS.CONFIRMATION)} $isCompleted={returnFormState.isStepCompleted(RETURN_STEPS.CONFIRMATION)}><StepHeader stepNumber={3} title="Podsumowanie" isActive={returnFormState.isStepActive(RETURN_STEPS.CONFIRMATION)} isCompleted={returnFormState.isStepCompleted(RETURN_STEPS.CONFIRMATION)} onEdit={() => returnFormState.resetStep(RETURN_STEPS.CONFIRMATION)} />{returnFormState.isStepActive(RETURN_STEPS.CONFIRMATION) && <div className="flex flex-col gap-4 min-h-[200px]"><div className="mb-6 border border-yellow-200 p-6 bg-yellow-50"><Text text={"Tw\xF3j zwrot jest prawie gotowy! Sprawd\u017A swoje dane i potwierd\u017A regulamin"} weight={TextWeight.BOLD} fontSize={TextSize.M} /></div><div className="flex flex-col gap-4 mb-4"><div className="flex flex-col gap-2"><Text text="Dane do zwrotu" weight={TextWeight.BOLD} fontSize={TextSize.M} /><div className="flex flex-row gap-1"><Text text="Numer konta:" fontSize={TextSize.S} /><Text text={userFormData?.accountNumber || ""} fontSize={TextSize.S} weight={TextWeight.SEMIBOLD} /></div><div className="flex flex-row gap-1"><Text text={"Imi\u0119 i nazwisko:"} fontSize={TextSize.S} /><Text text={userFormData?.name || ""} fontSize={TextSize.S} weight={TextWeight.SEMIBOLD} /></div><div className="flex flex-row gap-1"><Text text="Adres:" fontSize={TextSize.S} /><Text text={`${userFormData?.street} ${userFormData?.houseNumber} ${userFormData?.apartmentNumber}, ${userFormData?.postCode} ${userFormData?.city}`} fontSize={TextSize.S} weight={TextWeight.SEMIBOLD} /></div></div></div>{selectedReturnMethod?.idReturnMethod !== "1" && <div className="w-full mb-4"><div className={`border-2 p-4 cursor-pointer transition-all ${selectedPaymentMethod === "przelewy24" ? "border-blue-500 bg-blue-50" : "border-gray-200 hover:border-gray-300"}`} onClick={() => setSelectedPaymentMethod("przelewy24")}><div className="flex items-start gap-4"><div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center mt-1 ${selectedPaymentMethod === "przelewy24" ? "border-blue-500 bg-blue-500" : "border-gray-300"}`}>{selectedPaymentMethod === "przelewy24" && <div className="w-2 h-2 bg-white rounded-full" />}</div><div className="flex-1"><div className="flex items-center gap-2 mb-2"><Image src="https://upload.wikimedia.org/wikipedia/commons/e/e3/Przelewy24_logo.png" alt="Przelewy24" className="h-8 w-auto" width={100} height={37} /></div><Text textHtml={"Przelewy24 to bezpieczna i szybka metoda p\u0142atno\u015Bci. Wszystkie transakcje s\u0105 szyfrowane i zabezpieczone."} color={TextColor.GRAYSCALE_600} fontSize={TextSize.S} /></div></div></div></div>}<div className="p-4 border-2 border-gray-200 mb-4"><div className="space-y-2"><div className="mb-2"><Checkbox id="paymentTerms" name="paymentTerms" label="" labelHtml={"Zapozna\u0142em si\u0119 z <a href=\"https://carry.pl/regulamin-sklepu\" target=\"_blank\" class=\"text-blue-600 underline hover:text-blue-800\">regulaminem</a> oraz <a href=\"https://carry.pl/polityka-prywatnosci\" target=\"_blank\" class=\"text-blue-600 underline hover:text-blue-800\">polityk\u0105 prywatno\u015Bci</a> i akceptuj\u0119 ich postanowienia. <span class=\"text-red-500\">*</span>"} checked={paymentTerms} onChange={() => setPaymentTerms(!paymentTerms)} /></div><div className="flex justify-end items-center gap-2"><Text text={"Razem do zap\u0142aty"} fontSize={TextSize.S} /><Text text={`${parseFloat(selectedReturnMethod?.price || "0").toFixed(2)} zł`} fontSize={TextSize.S} weight={TextWeight.BOLD} /></div></div></div><div className="flex justify-end mt-auto"><Button text={loadingSubmit ? "Przetwarzanie..." : selectedReturnMethod?.idReturnMethod === "1" ? "Wygeneruj formularz" : "Zap\u0142a\u0107"} variant={ButtonVariant.PRIMARY} onClick={handleSubmit} disabled={loadingSubmit || !paymentTerms || selectedReturnMethod?.idReturnMethod !== "1" && !selectedReturnMethod} loading={loadingCreateCustomReturn} /></div></div>}</StepSection></div></div></div></div>;
    $[18] = customReturnForm;
    $[19] = customReturnUserForm;
    $[20] = dhlParcelPoint;
    $[21] = getNewsletterSection;
    $[22] = handleSubmit;
    $[23] = isUserFormValid;
    $[24] = loadingCreateCustomReturn;
    $[25] = loadingCustomReturnForm;
    $[26] = loadingSubmit;
    $[27] = paymentTerms;
    $[28] = returnFormState;
    $[29] = selectedPaymentMethod;
    $[30] = selectedProducts;
    $[31] = selectedReturnMethod;
    $[32] = userFormData?.accountNumber;
    $[33] = userFormData?.apartmentNumber;
    $[34] = userFormData?.city;
    $[35] = userFormData?.houseNumber;
    $[36] = userFormData?.name;
    $[37] = userFormData?.postCode;
    $[38] = userFormData?.street;
    $[39] = t11;
  } else {
    t11 = $[39];
  }
  let t12;
  if ($[40] !== customReturnForm || $[41] !== loadingCustomReturnForm) {
    t12 = !customReturnForm && !loadingCustomReturnForm && <div className="flex justify-center items-center h-full"><Text text={"Nie uda\u0142o si\u0119 za\u0142adowa\u0107 zam\xF3wienia"} /></div>;
    $[40] = customReturnForm;
    $[41] = loadingCustomReturnForm;
    $[42] = t12;
  } else {
    t12 = $[42];
  }
  let t13;
  if ($[43] !== t10 || $[44] !== t11 || $[45] !== t12 || $[46] !== t9) {
    t13 = <div className="relative w-full">{t9}{t10}{t11}{t12}</div>;
    $[43] = t10;
    $[44] = t11;
    $[45] = t12;
    $[46] = t9;
    $[47] = t13;
  } else {
    t13 = $[47];
  }
  return t13;
};

// Styled Components
const StepSection = styled.div`
  margin-bottom: 2rem;
  // opacity: ${({
  $isActive
}) => $isActive ? 1 : 0.5};
  transition: opacity 0.3s ease;
`;
export default CustomReturnForm;
function _temp(product) {
  return {
    idOrderDetail: product.idOrderDetail,
    quantityToReturn: parseInt(product.returnQuantity),
    returnReason: product.returnReason
  };
}
function _temp2() {
  console.log("Subscribe to newsletter");
}
function _temp3() {
  console.log("Verify subscription");
}
function _temp4(product_1) {
  return product_1.returnQuantity === "0" || product_1.returnReason === "";
}
function _temp5(product_2) {
  return product_2.returnQuantity === "0" || product_2.returnReason === "";
}